<template>
    <div class="land-plot-modal-bottom">
        <div class="land-plot-modal-bottom__slider">
            <SliderGallery
                v-if="landPlot.house?.images.length"
                :images="landPlot.house.images"
                mode="house"
            />

            <div
                v-else
                class="land-plot-modal-bottom__slider-placeholder"
            ></div>
        </div>

        <div class="land-plot-modal-bottom__info">
            <h2 class="land-plot-modal-bottom__info-title">
                {{ landPlot.house?.name }}
            </h2>

            <p class="land-plot-modal-bottom__info-subtitle">
                {{ landPlot.house ? landPlot.house.descriptionIn : '' }}
            </p>

            <CustomList
                v-if="listBottom.length"
                class="land-plot-modal-bottom__info-list"
                :list="listBottom"
                theme="even"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed } from 'vue';
    import CustomList from '@/components/commons/CustomList.vue';
    import SliderGallery from '@/components/slider/SliderGallery.vue';
    import { CustomListItem } from '@/types/common/CustomList';
    import { ILandPlot } from '@/types/LandPLot';

    const props = defineProps<{
        landPlot: ILandPlot;
    }>();

    const listBottom = computed<Array<CustomListItem>>(() => {
        if (props.landPlot.house)
            return props.landPlot.house.in.map(i => ({
                id: i.id,
                title: i.name,
                text: i.value,
            }));
        return [];
    });
</script>

<style lang="less">
    .land-plot-modal-bottom {
        padding: 60px 50px;
        background-color: @second-gray;
        display: grid;
        grid-template-columns: minmax(0, 1fr) 430px;
        gap: 34px;

        @media (max-width: @size-desktop-top) {
            display: block;
            padding: 20px;
        }

        // .land-plot-modal-bottom__info
        &__info {
            order: 1;

            // .land-plot-modal-bottom__info-title
            &-title {
                margin-bottom: 17px;
                font-size: 24px;
                line-height: 27.6px;
                color: @dark-brown;

                @media (max-width: @size-desktop-top) {
                    margin-bottom: 10px;
                    font-size: 18px;
                    line-height: 20.7px;
                }
            }

            // .land-plot-modal-bottom__info-subtitle
            &-subtitle {
                .text-3();

                color: @dark;

                @media (max-width: @size-desktop-top) {
                    .text-3-mobile();
                }
            }

            &-list {
                margin-top: 35px;

                @media (max-width: @size-desktop-top) {
                    margin-top: 20px;
                }
            }
        }

        // .land-plot-modal-bottom__slider
        &__slider {
            order: 2;

            @media (max-width: @size-desktop-top) {
                margin-bottom: 38px;
            }
        }

        &__slider-placeholder {
            background-color: rgba(@success, 0.5);
            height: 294px;

            @media (max-width: @size-desktop-top) {
                height: 415px;
            }

            @media (max-width: @size-mobile-top) {
                height: 205px;
            }
        }
    }
</style>
